<div class="row justify-content-center" [ngClass]="routeAnimationsElements">  
  <h2 class="mat-h2" mat-dialog-title>{{data.title}}</h2>

  <div [innerHtml]="data.contentText"></div>

  <ng-container *ngTemplateOutlet="customTemplate">
  </ng-container>

  <div class="row buttons d-flex justify-content-between pad" [ngClass]="routeAnimationsElements">
    <button type="reset" (click)="onCancel()" mat-raised-button [color]="data.cancelColor">
      {{ data.cancelText}}
    </button>
    <button type="submit" mat-raised-button (click)="onSubmit()" [color]="data.submitColor">
      {{ data.submitText}}
    </button>
  </div>  
</div>
